import multiyearOptions from "@/common/multiyear_options";

export const printOnlineMinimumQuantity = 10;

/**
 * SW-00-SS-EN-V1 => SW2
 * SW-02-SN-EN-V1 => SWSN2
 * WB-00-GE => WB0
 *
 * @param sku
 * @returns {*}
 */
export function displaySkuWithTopic(sku) {
    // SW-##-(SS|SN)
    if (sku.match(/SW-[0-9]{1,2}/) !== null) {

        if (sku.includes("SN"))
            sku = sku.replace("SW", "SWSN");

        // Get rid of 1st number. Always a 0 in this case.
        sku = sku.replace(/(SW|SWSN)-[0-9]{1}([0-9]{1})-(SS|SN|WB)/, "$1$2");

    }

    // WB-##
    else if (sku.match(/WB-[0-9]{1,2}/) !== null) {
        sku = sku.replace(/(WB)-([0-9]{1})/, "$1$2");
        sku = sku.replace("WB00", "WB0");
    }

    // ST-04-SS-EN-V1
    else if (sku.match(/[A-Z]{2}-[0-9]{1,2}-(SS|SN|WB)/) !== null) {
        sku = sku.replace(/([A-Z]{2})-[0-9]{1}([0-9]{1})-(SS|SN|WB|GE)/, "$1$3$2");
        sku = sku.replace(/([A-Z]{2})(SS)/, "$1");
    }

    if (sku.match(/S[0-9]{2}V[0-9]{2}/) !== null) {
        // Remove 2nd letter
        sku = sku.replace(/([0-9]{1})[0-9]{1}/, "$1");
    }

    // Get rid of EN-V1, EN-V1, EN-V1
    sku = sku.replace(/(-GE)*(-EN-V[0-9]{1,2})/, "");

    // Get rid of V16 in ESTX3V16
    return sku.replace(/V[0-9]{2}/, "");
}


export function productPricesOfFormat (productPrices, format, quantity, isHomeschoolStore = false) {
    if (!format || !productPrices)
        return;

    let formatPrices = [];

    for (let yearOption of multiyearOptions) {
        if (!productPrices[yearOption.value])
            continue;

        let pricesForYear = productPrices[yearOption.value];
        let yearPricingForFormat = {yearstotal: null, singleprice: null};

        // Check formats & add correct multiyear price.
        if (format === 'online_only' && quantity >= printOnlineMinimumQuantity && !isHomeschoolStore) {
            yearPricingForFormat.yearstotal = pricesForYear.online_only_yearstotal;
            yearPricingForFormat.singleprice = pricesForYear.online_only_singleprice;
        }
        else if (format === 'online_only') {
            yearPricingForFormat.yearstotal = pricesForYear.online_only_2_yearstotal;
            yearPricingForFormat.singleprice = pricesForYear.online_only_2_singleprice;
        }
        else if (format === 'print_online' && quantity >= printOnlineMinimumQuantity && !isHomeschoolStore) {
            yearPricingForFormat.yearstotal = pricesForYear.print_online_yearstotal;
            yearPricingForFormat.singleprice = pricesForYear.print_online_singleprice;
        }
        else if (format === 'print_online') {
            yearPricingForFormat.yearstotal = pricesForYear.print_online_2_yearstotal;
            yearPricingForFormat.singleprice = pricesForYear.print_online_2_singleprice;
        }

        // Add to pricing data structure.
        formatPrices[yearOption.value] = yearPricingForFormat;
    }

    return formatPrices
}

export function guidGenerator() {
    return 'xxxx-xxx-xxxx'.replace(/[x]/g, function(c) {
        let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

export function imageUrl(relativeUrl) {
    let encoded = encodeURIComponent(relativeUrl);
    return `https://cdn.studiesweekly.com/${encoded}`;
}

export function cleanS3Images(itemUrls) {
    // filter out 'Icon' resources created by S3 bucket
    _.remove(itemUrls, (o) => {
        return _.includes(o, 'Icon')
    })

    // filter out items that are not .jpg, .png or .gif
    _.remove(itemUrls, (o) => {
        return !_.includes(o, 'jpg') &&  !_.includes(o, 'jpeg') && !_.includes(o, 'png') && !_.includes(o, 'gif') && !_.includes(o, 'webp')
    })
    return itemUrls;
}